import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

		if(window.isMobile) {
			return;
		}

		this.bindMousemove = this.mousemove.bind(this);
        window.addEventListener("mousemove", this.bindMousemove);

		window.mouse = [0,0];
    }

	mousemove(e) {
		window.mouse = [e.clientX, e.clientY];
	}
}
